<template>
  <div
    :class="{
      anchor: true,
      footerShow: footerShow
    }"
    :style="{
      bottom: Number(top) + 120 + 'px'
    }"
  >
    <div class="anchor__service anchor__icon">
      <i
        class="iconfont health__customer"
        @mousemove="showService"
        @mouseout="serviceHide"
        @click="service"
      ></i>
    </div>
    <div class="anchor__phone anchor__icon">
      <i
        class="iconfont health__tel"
        @mouseover="phoneShow"
        @mouseout="phoneHide"
      ></i>
    </div>
    <div class="anchor__code anchor__icon">
      <i
        class="iconfont health__qrcode"
        @mouseover="qrcodeShow"
        @mouseout="qrcodeHide"
      ></i>
    </div>
    <!-- <div class="anchor__compare anchor__icon" v-if="flag_hidden != 1">
      <i
        class="iconfont health__contrast"
        @mousemove="buttonShow"
        @mouseout="buttonHide"
        @click="showCompareList"
      ></i>
    </div> -->
    <div class="anchor__totop anchor__icon" v-if="anchor_flag" id="top">
      <i
        class="iconfont health__back_top"
        v-if="!totophover"
        @mouseenter="bottomhover"
      ></i>
      <div
        v-else
        @mouseleave="bottomout"
        @click="totop"
        class="anchor__totopfont"
      >
        {{TLang('回到顶部','my')}}
      </div>
    </div>

    <div
      class="anchor__phone_hover"
      v-show="showPhone"
      @mouseover="phoneShow"
      @mouseout="phoneHide"
    >
      <div class="anchor__tiptitle">{{TLang('贴心客服热线','my')}}</div>
      <div class="anchor__actphone">{{tel}}</div>
      <div class="anchor__sevicetime" v-if="union == 'nyushanghai' && (!CheckCN() || union_isBilingual)">{{TLang('周一至周五','my')}}09:00-18:00</div>
      <div class="anchor__sevicetime" v-else>{{TLang('周一至周日','my')}}09:00-21:00</div>
    </div>

    <div
      class="anchor__qrcode_hover"
      v-show="showqrcode"
      @mouseover="qrcodeShow"
      @mouseout="qrcodeHide"
    >
      <img src="@/assets/imgs/qrcode.jpg" alt />
      <div class="anchor__sao">{{TLang('微信扫一扫关注东福','my')}}</div>
    </div>

    <!-- <div
      class="anchor__package_hover"
      v-show="showbutton"
      @mousemove="buttonShow"
      @mouseout="buttonHide"
      @click="showCompareList"
      v-if="flag_hidden != 1"
    >
      <div class="anchor__compare">点击查看套餐对比</div>
    </div> -->

    <div
      class="anchor__service_hover"
      v-show="serviceShow"
      @mousemove="showService"
      @mouseout="serviceHide"
      @click="service"
    >
      <div class="anchor__compareService">{{TLang('在线客服','my')}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { unionFlag } from "@/utils";
import { getCookie } from '../../utils';
export default {
  name: "anchor",
  data() {
    return {
      anchor_flag: false,
      showPhone: false,
      showqrcode: false,
      showbutton: true,
      totophover: false,
      serviceShow: false,
      tel: unionFlag() ? '400-618-2999' : '400-003-1010',
      df_lang: getCookie('df_lang'),
      union: unionFlag(),
    };
  },
  watch: {},
  props: ["flag_hidden", "footerShow", "top"],
  methods: {
    isBilingual() {
      const { isBilingual } = this.unionHead.mallUnionConfigDto;
      return isBilingual;
    },
    service() {
      try {
        window.qimoChatClick();
      } catch (error) {
        console.log(error);
      }
    },
    showService() {
      this.serviceShow = true;
    },
    serviceHide() {
      this.serviceShow = false;
    },
    phoneShow() {
      this.showPhone = true;
    },
    phoneHide() {
      this.showPhone = false;
    },
    qrcodeShow() {
      this.showqrcode = true;
    },
    qrcodeHide() {
      this.showqrcode = false;
    },
    buttonShow() {
      this.showbutton = true;
    },
    buttonHide() {
      this.showbutton = false;
    },
    showCompareList() {
      if (this.compareShow) {
        this.$store.commit("compareListControl", false);
      } else {
        this.$store.commit("compareListControl", true);
      }
    },
    bottomhover() {
      this.totophover = true;
    },
    bottomout() {
      this.totophover = false;
    },
    totop() {
      let scrollToptimer = setInterval(function() {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var speed = top / 3;
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top == 0) {
          clearInterval(scrollToptimer);
          this.totophover = false;
        }
      }, 30);
    },
    //监听是否滑动显示回到顶部
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop != 0) {
        this.anchor_flag = true;
      } else {
        this.anchor_flag = false;
        this.totophover = false;
      }
    }
  },
  computed: {
    ...mapState({
      compareShow: "compareShow"
    })
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }
};
</script>

<style lang="less" scoped>
.anchor {
  position: fixed;
  right: 0;
  bottom: 120px;
  width: 60px;
  box-sizing: border-box;
  &__icon {
    margin-bottom: 2px;
    background-color: #f7f7f7;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    .iconfont {
      font-size: 60px;
      cursor: pointer;
    }
    .iconfont:hover {
      background-color: @color-main;
      color: white;
    }
  }
  &__phone_hover {
    cursor: default;
    position: absolute;
    right: 60px;
    top: 15px;
    width: 178px;
    height: 107px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    padding: 20px;
  }
  &__phone_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 25px;
    line-height: 20px;
  }
  &__tiptitle {
    color: #999;
    font-size: 12px;
  }
  &__actphone {
    color: #333;
    font-weight: 600;
  }
  &__sevicetime {
    color: #999;
    margin-top: 10px;
  }
  &__qrcode_hover {
    cursor: default;
    position: absolute;
    right: 60px;
    top: 45px;
    font-size: 14px;
    color: #333333;
    width: 190px;
    height: 215px;
    padding: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    img {
      width: 170px;
      height: 170px;
    }
  }
  &__qrcode_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 100px;
    line-height: 20px;
  }
  &__package_hover {
    position: absolute;
    right: 60px;
    top: 186px;
    width: 172px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    line-height: 58px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }
  &__service_hover {
    position: absolute;
    right: 60px;
    top: 0;
    width: 172px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(240, 240, 240, 1);
    text-align: center;
    line-height: 58px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }
  &__service_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 25px;
    line-height: 20px;
  }
  &__package_hover:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid #fff;
    border-right: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    position: absolute;
    right: -10px;
    bottom: 25px;
    line-height: 20px;
  }
  &__totopfont {
    width: 100%;
    height: 100%;
    padding: 10px 10px 10px 13px;
    line-height: 20px;
    letter-spacing: 2px;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
  }
  &__totopfont:hover {
    background-color: @color-main;
    color: white;
  }
  .health__back_top {
    display: block;
  }
  // &__totopfont:hover {
  //   background-color: #08d0c2;
  //   color: white;
  // }
}
</style>
